<template>
  <a-modal
    v-model="visible"
    :title="name + (type == 1 ? '签字' : '录入指纹')"
    centered
    destroyOnClose
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    @ok="handleCancel"
    :getContainer="getContainer"
  >
    <div class="content_">
      <!-- 签名 -->
      <div class="content" @click="type = 1" :class="{ active: type == 1 }">
        <div class="msg" v-if="!signImg">请签字</div>
        <img v-else :src="signImg" width="100%" height="100%" alt="" />
      </div>
      <!-- 指纹 -->
      <div class="content" @click="type = 2" :class="{ active: type == 2 }">
        <div class="msg" v-if="!fingerImg">请进行指纹识别</div>
        <img :src="fingerImg" height="80%" alt="" />
      </div>
    </div>
    <div slot="footer" v-if="!disabled">
      <a-button @click="clearSign">清除</a-button>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" v-if="type == 1" @click="startSign"
        >{{ signImg ? "再次" : "开始" }}签字</a-button
      >
      <a-button type="primary" v-if="type == 2" @click="startfinger"
        >{{ fingerImg ? "再次" : "开始" }}录入指纹</a-button
      >
      <a-button
        type="primary"
        v-if="signImg && fingerImg"
        :loading="confirmLoading"
        @click="confirm"
        >保存</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import SignClient from "@/utils/sign/index";
import GetFingerImage from "@/utils/fingerprint/index";
import { ClippingImage, dataURLtoBlob } from "@/utils/os";
import { upload } from "@/request/sys";
import { personSign } from "@/request/person";
export default {
  props: {
    //是否只返回签字和指纹数据
    aloneBackData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      type: 1,
      userid: "",
      name: "",
      Sign: null,
      signImg: "", //签字图片
      Finger: null,
      fingerImg: "", //指纹图片
      confirmLoading: false,
      disabled: false, //
    };
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    init(record, disabled) {
      // this.disabled = disabled
      this.userid = record.id;
      this.name = record.name;
      this.signImg = record.sign ? record.sign : "";
      this.fingerImg = record.finger ? record.finger : "";
      this.visible = true;
    },
    //初始化签字板
    startSign() {
      if (!this.Sign) {
        this.Sign = new SignClient();
        this.Sign.setInitokCallback(() => {
          this.$message.success("请开始签字");
        });
        this.Sign.setInkCallback((base64) => {
          this.signImg = base64;
        });
        this.Sign.setErrCallback((res) => {
          this.$error({
            centered: true,
            title: "温馨提示",
            getContainer: ()=> document.getElementById("bodyContnet"),
            content: res.message,
            onOk: () => {
              // this.handleCancel();
            },
          });
        });
      }
      this.Sign.initDevice();
    },
    //清除签字板
    clearSign() {
      if (this.type == 1) {
        if (this.Sign) {
          this.Sign.clear();
        } else {
          this.signImg = "";
        }
      }
      if (this.type == 2) {
        this.fingerImg = "";
      }
    },
    //初始化指纹识别
    startfinger() {
      this.fingerImg = "";
      if (!this.Finger) {
        this.Finger = new GetFingerImage();
        this.Finger.setInitokCallback(() => {
          this.$message.success("请开始录入指纹");
        });
        this.Finger.setSuccessCallback((base64Image) => {
          ClippingImage(base64Image, 192, 255, 1, (res) => {
            this.fingerImg = res;
          });
        });
        this.Finger.setTimeoutCallback(() => {
          this.$confirm({
            title: "指纹录入超时，是否开始重新录入？",
            content: "请在在10秒进行内录入",
            okText: "重新录入",
            cancelText: "暂时不录入了",
            getContainer: ()=> document.getElementById("bodyContnet"),
            onOk: () => {
              console.log("OK");
              this.Finger.init();
            },
            onCancel: () => {
              console.log("Cancel");
            },
          });
        });
        this.Finger.setOfflineCallback(() => {
          this.$error({
            centered: true,
            getContainer: ()=> document.getElementById("bodyContnet"),
            title: "指纹采集器未连接",
            content: "请检查指纹采集器是否插入电脑的USB口",
            onOk: () => {
              // this.handleCancel();
            },
          });
        });
      }
      this.Finger.init();
    },
    destroy() {
      this.signImg = "";
      this.fingerImg = "";
      if (this.Sign) {
        this.Sign.close();
        this.Sign = null;
      }
      if (this.Finger) {
        this.Finger.close();
        this.Finger = null;
      }
    },
    //base64图片上传服务器返回url地址
    base64Upload(base64, name = "文件名称") {
      return new Promise((resovle, reject) => {
        if (base64.indexOf("http://") > -1 || base64.indexOf("https://") > -1) {
          return resovle({ data: { url: base64 } });
        }
        const file = dataURLtoBlob(base64, encodeURIComponent(name));
        let formData = new FormData();
        formData.append("file", file);
        upload(formData)
          .then((res) => {
            resovle(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    isBase64(data) {
      const base64Regex =
        /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;

      // 先检测是否满足 Base64 字符集的要求
      if (!base64Regex.test(data)) {
        return false;
      }

      try {
        // 使用 atob() 方法解码数据，如果抛出错误则不是有效的 Base64 编码
        const decodedData = atob(data);
        // 检查解码后的数据是否能再次编码回与原始数据相同的 Base64 字符串
        const reencodedData = btoa(decodedData);
        return reencodedData === data;
      } catch (error) {
        return false;
      }
    },
    //保存
    async confirm() {
      this.confirmLoading = true;
      const signUrl = new Promise(async (resolve, reject) => {
        try {
          let sign = await this.base64Upload(this.signImg);
          resolve(sign.data.url);
        } catch (e) {
          console.log(e);
          this.confirmLoading = false;
          reject(new Error("签名信息上传失败, 请重试"));
        }
      });
      const fingerUrl = new Promise(async (resolve, reject) => {
        try {
          let finger = await this.base64Upload(this.fingerImg);
          resolve(finger.data.url);
        } catch (e) {
          console.log(e);
          this.confirmLoading = false;
          reject(new Error("指纹信息上传失败, 请重试"));
        }
      });
      const results = await Promise.all([signUrl, fingerUrl]);
      console.log(results);
      const data = {
        id: this.userid,
        sign: results[0],
        finger: results[1],
      };
      if (this.aloneBackData) {
        this.confirmLoading = false;
        this.handleCancel();
        return this.$emit("aloneBackDataCallback", data);
      }
      personSign(data)
        .then(() => {
          this.$message.success("录入成功");
          this.$emit("query");
          this.handleCancel();
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    //关闭
    handleCancel() {
      this.destroy();
      this.type = 1;
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.content_ {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content {
  width: 387px;
  height: 244px;
  border: 1px solid #f5f6fa;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.active {
  border: 1px solid #0073ff;
}
.msg {
  font-size: 30px;
  line-height: 20px;
  color: #b9d5fd;
}
</style>